import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider as MuiLocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { getLocale } from './utils';

type Props = {
  children: React.ReactNode;
};

export const LocalizationProvider = ({ children }: Props) => {
  const locale = getLocale();

  return (
    <MuiLocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={locale}
    >
      {children}
    </MuiLocalizationProvider>
  );
};
